import React from 'react';

import DiscoveryEventItem from './discovery-event-item';
import SellEventItem from './sell-event-item';

/**
 * Defines a list of EventItem components based on number of events
 *
 * If app is sell, then instantiate the EventList for sell
 * Else, instantiate discovery's EventList
 *
 * Since sell's EventList needs to maintain state of selectable EventItem(s) whereas discovery's EventList is stateless
 */

/**
 *
 */
const EventItem = (props) => (props.isSell ? <SellEventItem {...props} /> : <DiscoveryEventItem {...props} />);

export default EventItem;
